require('./brokerFundamentalAnalysisResults.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { FormattedText, formatText } = require('core/i18n').i18n;
const classNames = require('classnames');
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

class BrokerFundamentalAnalysisResults extends React.Component {
    constructor(props) {
        super(props);
        this.handleBuyButtonClick = this.handleBuyButtonClick.bind(this);
    }

    handleBuyButtonClick() {
        this.props.history.push(`/myprofile/broker/stocksBuy/ES0113900J37/XMCE`); //@hardcoded
    }

    render() {
        const { results } = this.props;

        const resultsDisplay = classNames('broker-fundamental-analysis-results', {
            'broker-fundamental-analysis-results__hidden': results.size < 1
        });

        const PREFIX = 'broker-fundamentalAnalysisResults';
        const headerTitle = formatText(`${PREFIX}HeaderTitle`);
        const valueLabel = formatText(`${PREFIX}ValueLabel`);
        const titleLabel = formatText(`${PREFIX}TitleLabel`);
        const sectorLabel = formatText(`${PREFIX}SectorLabel`);
        const emissionDateLabel = formatText(`${PREFIX}EmissionDateLabel`);
        const buyLabel = formatText(`${PREFIX}BuyLabel`);
        const seeMoreLink = 'broker-fundamentalAnalysisResultsSeeMoreLink';

        const tableRows = results.map((result, index) => {
            return (
                <OKTableRow key={index}>
                    <OKTableCell className="broker-fundamental-analysis-results__table-cell broker-fundamental-analysis-results__table-cell--value">
                        {result.value}
                    </OKTableCell>
                    <OKTableCell className="broker-fundamental-analysis-results__table-cell broker-fundamental-analysis-results__table-cell--title">
                        {result.title}
                    </OKTableCell>
                    <OKTableCell className="broker-fundamental-analysis-results__table-cell broker-fundamental-analysis-results__table-cell--sector">
                        {result.sector}
                    </OKTableCell>
                    <OKTableCell className="broker-fundamental-analysis-results__table-cell broker-fundamental-analysis-results__table-cell--date-of-emittion">
                        {result.dateOfEmittion}
                    </OKTableCell>
                    <OKTableCell className="broker-fundamental-analysis-results__table-cell broker-fundamental-analysis-results__table-cell--actions">
                        <div className="broker-fundamental-analysis-results__action-group">
                            <div className="broker-fundamental-analysis-results__icon-pdf-container">
                                <i className="icon broker-fundamental-analysis-results__icon-pdf" />
                            </div>
                            <div className="broker-fundamental-analysis-results__button-buy-container">
                                <OKButton
                                    modifier="secondary"
                                    onClick={this.handleBuyButtonClick}
                                    size="small"
                                >
                                    {buyLabel}
                                </OKButton>
                            </div>
                        </div>
                    </OKTableCell>
                </OKTableRow>
            );
        });

        return (
            <ContentBox
                id="brokerSearchResults"
                customClassName={resultsDisplay}
            >
                <header className="broker-fundamental-analysis-results__header">
                    <h2 className="broker-fundamental-analysis-results__header-title">
                        {headerTitle}
                    </h2>
                </header>
                <OKTable className="broker-fundamental-analysis-results__table">
                    <thead>
                        <OKTableRow
                            asHeader={true}
                            className="broker-fundamental-analysis-results__table-header"
                        >
                            <OKTableCell
                                asHeader={true}
                                className="broker-fundamental-analysis-results__table-header-cell broker-fundamental-analysis-results__table-header-cell--value"
                            >
                                {valueLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="broker-fundamental-analysis-results__table-header-cell broker-fundamental-analysis-results__table-header-cell--title"
                            >
                                {titleLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="broker-fundamental-analysis-results__table-header-cell broker-fundamental-analysis-results__table-header-cell--sector"
                            >
                                {sectorLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="broker-fundamental-analysis-results__table-header-cell broker-fundamental-analysis-results__table-header-cell--date-of-emittion"
                            >
                                {emissionDateLabel}
                            </OKTableCell>
                            <OKTableCell
                                asHeader={true}
                                className="broker-fundamental-analysis-results__table-header-cell broker-fundamental-analysis-results__table-header-cell--actions"
                            />
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                    <tfoot className="broker-fundamental-analysis-results__table-footer">
                        <OKTableRow>
                            <OKTableCell
                                className="broker-fundamental-analysis-results__table-footer-cell"
                                colSpan={5}
                            >
                                <OKLink
                                    modifier="emphasize"
                                    to="#"
                                >
                                    <FormattedText
                                        value={seeMoreLink}
                                    />
                                </OKLink>
                            </OKTableCell>
                        </OKTableRow>
                    </tfoot>
                </OKTable>
            </ContentBox>
        );
    }
}

BrokerFundamentalAnalysisResults.propTypes = {
    history: PropTypes.object.isRequired,
    results: PropTypes.object
}

module.exports = withRouter(BrokerFundamentalAnalysisResults);
